"use client";

import {
  Stack,
  Box,
  Text,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Flex,
  Input,
  FormLabel,
  Select,
  Button,
  Spinner,
  IconButton,
} from "@chakra-ui/react"
import "services/Recruit/assets/css/CreateJobOpening/style.css"
import { experienceRangeOptions } from "services/Recruit/data/dropdownData";
import { ArrowBackIcon, DeleteIcon, DownloadIcon, CloseIcon } from "@chakra-ui/icons"
import { globalStyles } from "common/theme/styles"
import { AttachmentIcon } from "services/Recruit/assets/svg/AttachmentIcon"
import { Field, Formik, Form } from "formik"
import { useEffect, useState, useMemo, useCallback } from "react"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import { constant } from "common/constant"
import FileUpload from "common/components/fileUpload/FileUpload"
import ActionNavbar from "common/components/actionBar/ActionNavbar"
import { useDispatch, useSelector } from "react-redux"
import { getDepartments } from "common/redux/reducers/departmentSlice"
import { fetchUserData } from "common/redux/reducers/userSlice"
import { candidateTabs } from "services/Recruit/data/candidate"
import ReactSelect from "react-select"
import { recruitConstant } from "services/Recruit/constant"
import { candidateStageOptions } from "services/Recruit/data/dropdownData"
import { indianStatesOptions } from "services/Recruit/data/dropdownData"
import { applicationSourceOptions } from "services/Recruit/data/dropdownData"
import { qualificationOptions } from "services/Recruit/data/dropdownData"
import { requiredSkillsOptions } from "services/Recruit/data/dropdownData"
import { jobTitleOptions } from "services/Recruit/data/dropdownData"
import { getApi } from "common/services/api"
import { API_PATHS } from "common/services/apiPaths"
import { toast } from "react-toastify"
import { candidateValidationSchema } from "services/Recruit/schema/candidateSchema"
import { CANDIDATE_INITIAL_VALUES } from "common/initialValues/formInitialValues"
import { addCandidate } from "common/redux/reducers/candidateSlice"
import { cleanFormDataCandidate } from "common/utils/formDataCleanerCandidate"
import { updateCandidate, downloadAttachment } from "common/redux/reducers/candidateSlice"
import { noticePeriodOptions } from "services/Recruit/data/dropdownData"
import { MAX_ATTACHMENT_FILE_SIZE, MAX_ATTACHMENT_FILE_SIZE_MB } from "services/Crm/utils/calcUtils"
import { ACCEPTED_DOCUMENT_TYPES } from "services/Crm/utils/calcUtils"
import * as Yup from "yup"
import { capitalizeWords } from "common/utils/textFormatters"
import { HasAccess } from "common/utils/accessUtils";
import { accessModuleTitles } from "common/constant";
import { applicationStatusLabels } from "common/constant";
import axios from "axios";
import S3Helper from "common/utils/s3-helper";
import { extractS3KeyFlexible } from "services/Crm/utils/calcUtils";
import { removeTimestamp } from "services/Crm/utils/calcUtils";
import { validateS3File } from "services/Crm/utils/calcUtils";
import { generateS3Path } from "services/Crm/utils/calcUtils";
import { candidateStatusOptions } from "common/constant";
import { isFormDirty } from "common/utils/formUtils";
import Interview from "../interview";
import Application from "../application";
import { fileFieldMapping } from "services/Crm/utils/calcUtils";
import CustomDatePicker from "common/components/datePicker/CustomDatePicker";
import DocumentVerificationTab from "services/Recruit/components/DocumentVerification/DocumentVerificationTab";
import LOITab from "services/Recruit/components/LOI/LOITab";
import CreatableSelect from "react-select/creatable";

const OverviewPanel = (
  {
    navigate,
    isOverviewMode,
    id,
    jobData,
    handleFormSubmit,
    handleFileSelection,
    handleRemoveFile,
    handleDownloadAttachment,
    pendingUploads,
    users,
    permission,
    colors,
    activeTabIndex,
    getTabStates,
    handleTabChange,
    handleNext,
    handleBack,
    addLoading,
    editLoading,
    isAnyFileUploading,
    isEditMode,
    originalCandidateData,
    showSizeError,
    visibleTabs,
    getUserRole,
    jobTitleDropdownOptions,
  }
) => {
  return (
    <>
      <Box className="createJobOpening-container">
        <Box className="createJobOpening-mainContainer">
          <Box className="createJobOpening-breadCrumb">
            <ArrowBackIcon
              onClick={() => navigate(-1)}
              fontSize="20px"
              cursor="pointer"
            />
            <Text className="createJobOpening-pageTitle">
              {isOverviewMode ? "Overview" : id ? recruitConstant.editCandidates : recruitConstant.createCandidates}
            </Text>
          </Box>
        </Box>

        <Formik
          enableReinitialize
          initialValues={
            jobData
              ? {
                ...jobData,
                owner: jobData?.owner || "",
                status:
                  typeof jobData.status === "string"
                    ? jobData.status.toLowerCase()
                    : Array.isArray(jobData.status) && jobData.status.length > 0
                      ? jobData.status[0].toLowerCase()
                      : "",
                state:
                  typeof jobData.state === "string"
                    ? jobData.state
                    : Array.isArray(jobData.state) &&
                      jobData.state.length > 0
                      ? jobData.state[0]
                      : "",
                source:
                  typeof jobData.source === "string"
                    ? jobData.source
                    : Array.isArray(jobData.source) &&
                      jobData.source.length > 0
                      ? jobData.source[0]
                      : "",
                skills:
                  typeof jobData.skills === "string"
                    ? jobData.skills
                      ? [jobData.skills]
                      : []
                    : Array.isArray(jobData.skills)
                      ? jobData.skills
                      : [],
              }
              : {
                ...CANDIDATE_INITIAL_VALUES,
                skills: [],
              }
          }
          validationSchema={candidateValidationSchema}
          onSubmit={handleFormSubmit}
        >
          {({
            values,
            setFieldValue,
            handleSubmit,
            errors,
            dirty,
            isValid,
            setErrors,
            setTouched,
          }) => {
            const tabStates = getTabStates(
              values,
              dirty,
              isValid,
              activeTabIndex
            );
            console.log(errors, 'errorsew435432');

            const reStructuredVal = values;

            const {
              customJobTitle,
              customHighestQualification,
              customSource,
              ...baseValues
            } = reStructuredVal;

            let finalValues = { ...baseValues };

            if (values?.currentJobTitle?.startsWith("Other-")) {
              finalValues.customJobTitle = customJobTitle;
            }
            if (values?.highestQualification?.startsWith("Other-")) {
              finalValues.customHighestQualification = customHighestQualification;
            }
            if (values?.source?.startsWith("Other-")) {
              finalValues.customSource = customSource;
            }

            const isDirty = isFormDirty(
              originalCandidateData || CANDIDATE_INITIAL_VALUES,
              finalValues
            );

            return (
              <Form onSubmit={handleSubmit}>
                <Tabs
                  index={activeTabIndex}
                  onChange={(index) =>
                    handleTabChange(index, values, dirty, isValid)
                  }
                  className="createJobOpening-tabsContainer"
                  variant="unstyled"
                  orientation="vertical"
                >
                  <TabList
                    w={"40%"}
                    className="createJobOpening-tabListContainer"
                  >
                    {visibleTabs.map(({ label, Icon }, index) => {
                      // Map visible tab index to original tab index
                      const originalIndex = candidateTabs.findIndex(tab => tab.label === label);
                      const tabState = tabStates[originalIndex] || { isAccessible: false, isValid: false };
                      const isCurrentTab = originalIndex === activeTabIndex;

                      return (
                        <Tab
                          className="createJobOpening-tabs"
                          key={originalIndex}
                          _selected={{
                            color: colors.cta["100"],
                            borderLeft: "2px solid",
                            borderColor: colors.cta["100"],
                          }}
                          _hover={{
                            color: tabState.isAccessible
                              ? colors.cta["100"]
                              : "inherit",
                            cursor: tabState.isAccessible
                              ? "pointer"
                              : "not-allowed",
                          }}
                          _focus={{ boxShadow: "none" }}
                          display="flex"
                          alignItems="center"
                          gap="8px"
                          opacity={tabState.isAccessible ? 1 : 0.6}
                          cursor={
                            tabState.isAccessible
                              ? "pointer"
                              : "not-allowed"
                          }
                          isDisabled={!tabState.isAccessible}
                        >
                          <Icon size={20} />
                          {label}
                          {tabState?.isValid && (
                            <Text fontSize="xs" color="green.500">
                              ✓
                            </Text>
                          )}
                        </Tab>
                      );
                    })}
                  </TabList>

                  <TabPanels
                    w={"60%"}
                    className="createJobOpening-tabsPanelContainer"
                  >
                    {/* Render TabPanels based on visibleTabs order to match TabList */}
                    {visibleTabs.map(({ label }, visibleIndex) => {
                      // Find the original index of this tab
                      const originalIndex = candidateTabs.findIndex(tab => tab.label === label);

                      // Render the appropriate TabPanel based on original index
                      if (originalIndex === 0) {
                        // Candidate Details tab
                        return (
                          <TabPanel key={`tab-${originalIndex}`} className="createJobOpening-tabsPanel">
                            {/* ... All existing personal info fields remain exactly the same ... */}
                            <Box className="createJobOpening-tabsPanelBody">
                              {/* Personal info fields unchanged - showing abbreviated version */}
                              <Flex gap={"20px"}>
                                <Box w={"50%"}>
                                  <FormLabel htmlFor="name">
                                    {recruitConstant.name}
                                    <span className="astrick">*</span>
                                  </FormLabel>
                                  <Field name="name">
                                    {({ field, meta, form }) => {
                                      return (
                                        <>
                                          <Input
                                            isDisabled={!permission?.update || isOverviewMode}
                                            name={field.name}
                                            value={field.value || ''}
                                            placeholder={recruitConstant.enterFullName}
                                            maxLength={50}
                                            onChange={(e) => {
                                              let value = e.target.value;
                                              if (value.startsWith(' ')) {
                                                value = value.trimStart();
                                              }
                                              value = value.replace(/[^a-zA-Z\s]/g, '');
                                              form.setFieldValue(field.name, value, true);
                                            }}
                                            onBlur={() => {
                                              const trimmedValue = (field.value || '').trim();
                                              form.setFieldValue(field.name, trimmedValue, true);
                                              form.setFieldTouched(field.name, true, true);
                                            }}
                                            borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                          />
                                          {meta.touched && meta.error && (
                                            <Text color={colors.errorText} fontSize="sm" mt={1}>
                                              {meta.error}
                                            </Text>
                                          )}
                                        </>
                                      );
                                    }}
                                  </Field>
                                </Box>


                                <Box w={"50%"}>
                                  <FormLabel htmlFor="phone">
                                    {recruitConstant.phoneNumber}
                                    <span className="astrick">*</span>
                                  </FormLabel>
                                  <Field name="phone">
                                    {({ field, meta, form }) => {
                                      return (
                                        <>
                                          <Input
                                            isDisabled={!permission?.update || isOverviewMode}
                                            name={field.name}
                                            value={field.value || ''}
                                            placeholder={recruitConstant.phonePlaceHolderText}
                                            type="tel"
                                            maxLength={10}
                                            onChange={(e) => {
                                              const value = e.target.value.replace(/\D/g, ''); // Only digits
                                              if (value.length <= 10) {
                                                form.setFieldValue(field.name, value, true);
                                              }
                                            }}
                                            onKeyDown={(e) => {
                                              const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete"];
                                              const isCopyPaste = (e.ctrlKey || e.metaKey) && ["c", "v", "x", "a"].includes(e.key.toLowerCase());
                                              const isNumber = /^[0-9]$/.test(e.key);
                                              if (isCopyPaste) return;
                                              if (e.currentTarget.value.length >= 10 && !allowedKeys.includes(e.key)) {
                                                e.preventDefault();
                                                return;
                                              }
                                              if (!isNumber && !allowedKeys.includes(e.key)) {
                                                e.preventDefault();
                                              }
                                            }}
                                            onPaste={(e) => {
                                              e.preventDefault();
                                              const pastedData = e.clipboardData.getData('text');
                                              const numericData = pastedData.replace(/\D/g, '').slice(0, 15);
                                              form.setFieldValue(field.name, numericData, true);
                                            }}
                                            onBlur={() => {
                                              form.setFieldTouched(field.name, true, true);
                                            }}
                                            borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                          />
                                          {meta.touched && meta.error && (
                                            <Text color={colors.errorText} fontSize="sm" mt={1}>
                                              {meta.error}
                                            </Text>
                                          )}
                                        </>
                                      );
                                    }}
                                  </Field>
                                </Box>
                              </Flex>

                              <Flex gap={"20px"}>
                                <Box w={"50%"}>
                                  <FormLabel htmlFor="email">
                                    {recruitConstant.email}
                                    <span className="astrick">*</span>
                                  </FormLabel>
                                  <Field name="email">
                                    {({ field, meta, form }) => {
                                      return (
                                        <>
                                          <Input
                                            isDisabled={!permission?.update || isOverviewMode}
                                            name={field.name}
                                            value={field.value || ''}
                                            placeholder={recruitConstant.emailPlaceHolderText}
                                            maxLength={100}
                                            onChange={(e) => {
                                              let value = e.target.value.replace(/\s/g, ''); // No spaces
                                              value = value.replace(/[^a-zA-Z0-9._%+\-@]/g, ''); // Only valid email chars
                                              value = value.replace(/^[^a-zA-Z0-9]+/, ''); // Must start with letter or number
                                              value = value.replace(/\.{2,}/g, '.'); // Prevent consecutive dots
                                              form.setFieldValue(field.name, value, true);
                                            }}
                                            onBlur={() => {
                                              const trimmedValue = (field.value || '').trim().toLowerCase();
                                              form.setFieldValue(field.name, trimmedValue, true);
                                              form.setFieldTouched(field.name, true, true);
                                            }}
                                            borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                          />
                                          {meta.touched && meta.error && (
                                            <Text color={colors.errorText} fontSize="sm" mt={1}>
                                              {meta.error}
                                            </Text>
                                          )}
                                        </>
                                      );
                                    }}
                                  </Field>
                                </Box>

                                <Box w={"50%"}>
                                  <FormLabel htmlFor="state">
                                    {constant.stateAndTerritory}
                                  </FormLabel>
                                  <Field name="state">
                                    {({ field, meta }) => (
                                      <>
                                        <Select
                                          isDisabled={!permission?.update || isOverviewMode}
                                          {...field}
                                          borderColor={
                                            meta.touched && meta.error
                                              ? colors.errorText
                                              : colors.borderColor
                                          }
                                          value={field.value || ""}
                                        >
                                          {indianStatesOptions.map((state) => (
                                            <option
                                              key={state.value}
                                              value={state.value}
                                              disabled={state.disabled}
                                              hidden={state.hidden}
                                            >
                                              {state.label}
                                            </option>
                                          ))}
                                        </Select>
                                        {meta.touched && meta.error && (
                                          <Text color={colors.errorText} fontSize="sm" mt={1}>
                                            {meta.error}
                                          </Text>
                                        )}
                                      </>
                                    )}
                                  </Field>
                                </Box>
                              </Flex>

                              <Flex gap={"20px"}>
                                <Box w={"50%"}>
                                  <FormLabel htmlFor="city">
                                    {recruitConstant.city}
                                  </FormLabel>
                                  <Field name="city">
                                    {({ field, meta, form }) => {
                                      console.log('City field - value:', field.value, 'touched:', meta.touched, 'error:', meta.error);
                                      return (
                                        <>
                                          <Input
                                            isDisabled={!permission?.update || isOverviewMode}
                                            name={field.name}
                                            value={field.value || ''}
                                            placeholder={recruitConstant.enterCity}
                                            maxLength={50}
                                            onChange={(e) => {
                                              let value = e.target.value;
                                              if (value.startsWith(' ')) {
                                                value = value.trimStart();
                                              }
                                              value = value.replace(/[^a-zA-Z\s]/g, '');
                                              value = value.replace(/\s{2,}/g, ' ');
                                              form.setFieldValue(field.name, value, true); // 3rd param triggers validation
                                            }}
                                            onBlur={() => {
                                              const trimmedValue = (field.value || '').trim();
                                              form.setFieldValue(field.name, trimmedValue, true);
                                              form.setFieldTouched(field.name, true, true); // 3rd param triggers validation
                                            }}
                                            borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                          />
                                          {meta.touched && meta.error && (
                                            <Text color={colors.errorText} fontSize="sm" mt={1}>
                                              {meta.error}
                                            </Text>
                                          )}
                                        </>
                                      );
                                    }}
                                  </Field>
                                </Box>

                                <Box w={"50%"}>
                                  <FormLabel htmlFor="status">
                                    {recruitConstant.status}
                                    <span className="astrick">*</span>
                                  </FormLabel>
                                  <Field name="status">
                                    {({ field, meta }) => (
                                      <>
                                        <Select
                                          isDisabled={!permission?.update || isOverviewMode}
                                          {...field}
                                          value={field.value || ""}
                                          borderColor={
                                            meta.touched && meta.error
                                              ? colors.errorText
                                              : colors.borderColor
                                          }
                                        >
                                          <option hidden value="">
                                            {recruitConstant.selectStatus}
                                          </option>
                                          {candidateStatusOptions.map((option) => (
                                            <option key={option.value} value={option.value}>
                                              {option.label}
                                            </option>
                                          ))}
                                        </Select>
                                        {meta.touched && meta.error && (
                                          <Text color={colors.errorText} fontSize="sm" mt={1}>{meta.error}</Text>
                                        )}
                                      </>
                                    )}
                                  </Field>
                                </Box>
                              </Flex>



                              <Flex gap={"20px"}>
                                <Box w={"50%"}>
                                  <FormLabel htmlFor="source">
                                    {recruitConstant.applicationSource}
                                    <span className="astrick">*</span>
                                  </FormLabel>
                                  <Field name="source">
                                    {({ field, meta, form }) => {
                                      const currentValue = field.value; // can be normal or other-<custom>
                                      const customText = form.values.customSource || "";

                                      // Show input if user selects "Other"
                                      const isOtherSelected = currentValue === "Other";

                                      // Always show "Other" in options
                                      const applicationSourceOptionssWithOther = [
                                        ...applicationSourceOptions.filter((opt) => opt.value !== "Other" && opt.value !== "others"),
                                        { label: "Other", value: "Other" },
                                      ];

                                      // Selected option: value must match option to highlight
                                      const selectedOption = currentValue?.startsWith("Other-")
                                        ? { label: `${currentValue.split("Other-")[1]}`, value: "Other" } // <- value = "Other"
                                        : applicationSourceOptionssWithOther.find((opt) => opt.value === currentValue) || null

                                      return (
                                        <>
                                          <ReactSelect
                                            isDisabled={!permission?.update || isOverviewMode}
                                            name={field.name}
                                            value={selectedOption}
                                            onBlur={() => form.setFieldTouched(field.name, true)}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            options={applicationSourceOptionssWithOther}
                                            className="basic-single-select reactSelect"
                                            classNamePrefix="select"
                                            onChange={(selectedOption) => {
                                              const selectedValue = selectedOption ? selectedOption.value : "";
                                              if (selectedValue === "Other") {
                                                // Open text input with previous value if exists
                                                const prevCustom = currentValue?.startsWith("Other-")
                                                  ? currentValue.split("Other-")[1]
                                                  : "";
                                                form.setFieldValue("customSource", prevCustom);
                                                form.setFieldValue("source", "Other"); // keep dropdown selection as "Other"
                                              } else {
                                                form.setFieldValue("source", selectedValue);
                                                if (originalCandidateData?.source.startsWith('Other-'))
                                                  form.setFieldValue("customSource", "")
                                              }
                                            }}
                                            placeholder={recruitConstant.selectSource}
                                            isClearable
                                            isSearchable
                                            styles={{
                                              control: (provided) => ({
                                                ...provided,
                                                borderColor:
                                                  meta.error ? colors.errorText : colors.borderColor,
                                              }),
                                            }}
                                          />

                                          {isOtherSelected && (
                                            <Box mt={2}>
                                              <Input
                                                placeholder="Enter custom source"
                                                value={form.values.customSource || ""}
                                                autoFocus
                                                onChange={(e) => {
                                                  let val = e.target.value
                                                  if (val.startsWith(" ")) return
                                                  form.setFieldValue("customSource", val)
                                                }}
                                                onBlur={() => {
                                                  let customValue = form.values.customSource
                                                    ?.trim()

                                                  if (customValue) {
                                                    form.setFieldValue("customSource", customValue)
                                                    form.setFieldValue("source", `Other-${customValue}`)
                                                  } else {
                                                    if (originalCandidateData?.source.startsWith('Other-'))
                                                      form.setFieldValue("customSource", "")
                                                    form.setFieldValue("source", "Other")
                                                  }
                                                }}
                                                onKeyDown={(e) => {
                                                  if (e.key === "Enter") {
                                                    e.preventDefault()
                                                    let customValue = form.values.customSource
                                                      ?.trim()
                                                    if (customValue) {
                                                      form.setFieldValue("customSource", customValue)
                                                      form.setFieldValue("source", `Other-${customValue}`)
                                                    }
                                                  }
                                                }}
                                              />
                                            </Box>
                                          )}

                                          {meta.touched && (meta.error || (meta?.value === 'Other' && !form.values.customSource)) && (
                                            <Text color={colors.errorText} fontSize="sm" mt={1}>
                                              {meta.error ?? ((meta?.value === 'Other' && !form.values.customSource) ? 'Please enter a custom source ' : '')}
                                            </Text>
                                          )}
                                        </>
                                      )
                                    }}
                                  </Field>
                                </Box>

                                <Box w={"50%"}>
                                  <FormLabel htmlFor="owner">
                                    {recruitConstant.recruiter}
                                    <span className="astrick">*</span>
                                  </FormLabel>
                                  <Field name="owner">
                                    {({ field, meta }) => (
                                      <>
                                        <Select
                                          isDisabled={!permission?.update || isOverviewMode}
                                          {...field}
                                          defaultValue=""
                                          borderColor={
                                            meta.touched && meta.error
                                              ? colors.errorText
                                              : colors.borderColor
                                          }
                                        >
                                          <option selected hidden value="">
                                            {recruitConstant.selectOwner}
                                          </option>
                                          {users?.length > 0 &&
                                            users.map(
                                              (option) =>
                                                option.roles.find(
                                                  (role) => role.roleName === "recruiter"
                                                ) && (
                                                  <option key={option._id} value={option._id}>
                                                    {option.firstName + " " + option.lastName}
                                                  </option>
                                                )
                                            )}
                                        </Select>
                                        {meta.touched && meta.error && (
                                          <Text color={colors.errorText} fontSize="sm" mt={1}>
                                            {meta.error}
                                          </Text>
                                        )}
                                      </>
                                    )}
                                  </Field>
                                </Box>
                              </Flex>

                              <Flex gap={"20px"}>
                                <Box w={"50%"}>
                                  <FormLabel htmlFor="highestQualification">
                                    {recruitConstant.highestQualification}
                                    <span className="astrick">*</span>
                                  </FormLabel>
                                  <Field name="highestQualification">
                                    {({ field, meta, form }) => {
                                      const currentValue = field.value; // can be normal or other-<custom>
                                      const customText = form.values.customHighestQualification || "";

                                      // Show input if user selects "Other"
                                      const isOtherSelected = currentValue === "Other";

                                      // Always show "Other" in options
                                      const higherQualificationOptionsWithOther = [
                                        ...qualificationOptions.filter((opt) => opt.value !== "Other" && opt.value !== "others"),
                                        { label: "Other", value: "Other" },
                                      ];

                                      // Selected option: value must match option to highlight
                                      const selectedOption = currentValue?.startsWith("Other-")
                                        ? { label: `${currentValue.split("Other-")[1]}`, value: "Other" } // <- value = "Other"
                                        : higherQualificationOptionsWithOther.find((opt) => opt.value === currentValue) || null

                                      return (
                                        <>
                                          <ReactSelect
                                            isDisabled={!permission?.update || isOverviewMode}
                                            name={field.name}
                                            value={selectedOption}
                                            onBlur={() => form.setFieldTouched(field.name, true)}
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            options={higherQualificationOptionsWithOther}
                                            className="basic-single-select reactSelect"
                                            classNamePrefix="select"
                                            onChange={(selectedOption) => {
                                              const selectedValue = selectedOption ? selectedOption.value : "";
                                              if (selectedValue === "Other") {
                                                // Open text input with previous value if exists
                                                const prevCustom = currentValue?.startsWith("Other-")
                                                  ? currentValue.split("Other-")[1]
                                                  : "";
                                                form.setFieldValue("customHighestQualification", prevCustom);
                                                form.setFieldValue("highestQualification", "Other"); // keep dropdown selection as "Other"
                                              } else {
                                                form.setFieldValue("highestQualification", selectedValue);
                                                if (originalCandidateData?.highestQualification.startsWith('Other-'))
                                                  form.setFieldValue("customHighestQualification", "")
                                              }
                                            }}
                                            placeholder={recruitConstant.selectHighestQualification}
                                            isClearable
                                            isSearchable
                                            styles={{
                                              control: (provided) => ({
                                                ...provided,
                                                borderColor:
                                                  meta.error ? colors.errorText : colors.borderColor,
                                              }),
                                            }}
                                          />

                                          {isOtherSelected && (
                                            <Box mt={2}>
                                              <Input
                                                placeholder="Enter custom highest qualification"
                                                value={form.values.customHighestQualification || ""}
                                                autoFocus
                                                onChange={(e) => {
                                                  let val = e.target.value
                                                  if (val.startsWith(" ")) return
                                                  form.setFieldValue("customHighestQualification", val)
                                                }}
                                                onBlur={() => {
                                                  let customValue = form.values.customHighestQualification
                                                    ?.trim()

                                                  if (customValue) {
                                                    form.setFieldValue("customHighestQualification", customValue)
                                                    form.setFieldValue("highestQualification", `Other-${customValue}`)
                                                  } else {
                                                    if (originalCandidateData?.highestQualification.startsWith('Other-'))
                                                      form.setFieldValue("customHighestQualification", "")
                                                    form.setFieldValue("highestQualification", "Other")
                                                  }
                                                }}
                                                onKeyDown={(e) => {
                                                  if (e.key === "Enter") {
                                                    e.preventDefault()
                                                    let customValue = form.values.customHighestQualification
                                                      ?.trim()
                                                    if (customValue) {
                                                      form.setFieldValue("customHighestQualification", customValue)
                                                      form.setFieldValue("highestQualification", `Other-${customValue}`)
                                                    }
                                                  }
                                                }}
                                              />
                                            </Box>
                                          )}

                                          {(meta.touched && meta.error || (meta?.value === 'Other' && !form.values.customHighestQualification)) && (
                                            <Text color={colors.errorText} fontSize="sm" mt={1}>{meta.error ?? ((meta?.value === 'Other' && !form.values.customHighestQualification) ? 'Please enter a custom highest qualification ' : '')}</Text>
                                          )}
                                        </>
                                      )
                                    }}
                                  </Field>
                                </Box>
                                <Box w={"50%"}>
                                  <FormLabel htmlFor="experienceRange">
                                    Total Experience
                                    <span className="astrick">*</span>
                                  </FormLabel>
                                  <Field name="experienceRange">
                                    {({ field, form, meta }) => (
                                      <>
                                        <Select
                                          {...field}
                                          placeholder="Select experience range"
                                          isDisabled={!permission?.update || isOverviewMode}
                                          borderColor={
                                            meta.touched && meta.error
                                              ? colors.errorText
                                              : colors.borderColor
                                          }
                                          onChange={(e) => form.setFieldValue("experienceRange", e.target.value)}
                                        >
                                          {experienceRangeOptions.map((option) => (
                                            <option key={option.value} value={option.value}>
                                              {option.label}
                                            </option>
                                          ))}
                                        </Select>
                                        {meta.touched && meta.error && (
                                          <Text color={colors.errorText} fontSize="sm" mt={1}>{meta.error}</Text>
                                        )}
                                      </>
                                    )}
                                  </Field>
                                </Box>
                              </Flex>

                              <Flex gap={"20px"}>


                                <Box w={"50%"}>
                                  <FormLabel htmlFor="currentCTC">
                                    Current CTC (LPA)
                                  </FormLabel>
                                  <Field name="currentCTC">
                                    {({ field, meta, form }) => {
                                      return (
                                        <>
                                          <Input
                                            isDisabled={!permission?.update || isOverviewMode}
                                            name={field.name}
                                            value={field.value || ''}
                                            placeholder="Enter Current CTC"
                                            type="text"
                                            inputMode="numeric"
                                            maxLength={6}
                                            onChange={(e) => {
                                              let value = e.target.value.replace(/[^0-9.]/g, ''); // Allow only digits and dot
                                              const parts = value.split('.');
                                              if (parts.length > 2) return; // Prevent multiple dots
                                              if (parts[0].length > 2) return; // Restrict integer part to 2 digits 
                                              if (parts[1] && parts[1].length > 2) return; // Restrict decimal part to 2 digits
                                              form.setFieldValue(field.name, value, true);
                                            }}
                                            onKeyDown={(e) => {
                                              const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete", "."];
                                              const isCopyPaste = (e.ctrlKey || e.metaKey) && ["c", "v", "x", "a"].includes(e.key.toLowerCase());
                                              const isNumber = /^[0-9]$/.test(e.key);
                                              const isDot = e.key === ".";

                                              if (isCopyPaste) return;

                                              // Prevent multiple dots
                                              if (isDot && e.currentTarget.value.includes(".")) {
                                                e.preventDefault();
                                                return;
                                              }

                                              if (!isNumber && !isDot && !allowedKeys.includes(e.key)) {
                                                e.preventDefault();
                                              }
                                            }}
                                            onPaste={(e) => {
                                              e.preventDefault();
                                              const pastedData = e.clipboardData.getData('text');
                                              const cleanedData = pastedData.replace(/[^0-9.]/g, '');
                                              const parts = cleanedData.split('.');
                                              let result = parts[0].slice(0, 2);
                                              if (parts.length > 1) {
                                                result += '.' + parts[1].slice(0, 2);
                                              }
                                              form.setFieldValue(field.name, result, true);
                                            }}
                                            onBlur={() => {
                                              form.setFieldTouched(field.name, true, true);
                                            }}
                                            borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                          />
                                          {meta.touched && meta.error && (
                                            <Text color={colors.errorText} fontSize="sm" mt={1}>
                                              {meta.error}
                                            </Text>
                                          )}
                                        </>
                                      );
                                    }}
                                  </Field>
                                </Box>
                                <Box w={"50%"}>
                                  <FormLabel htmlFor="expectedCTC">
                                    Expected CTC (LPA)
                                  </FormLabel>
                                  <Field name="expectedCTC">
                                    {({ field, meta, form }) => {
                                      return (
                                        <>
                                          <Input
                                            isDisabled={!permission?.update || isOverviewMode}
                                            name={field.name}
                                            value={field.value || ''}
                                            placeholder="Enter Expected CTC"
                                            type="text"
                                            inputMode="numeric"
                                            maxLength={6}
                                            onChange={(e) => {
                                              let value = e.target.value.replace(/[^0-9.]/g, ''); // Allow only digits and dot
                                              const parts = value.split('.');
                                              if (parts.length > 2) return; // Prevent multiple dots
                                              if (parts[0].length > 2) return; // Restrict integer part to 2 digits as requested
                                              if (parts[1] && parts[1].length > 2) return; // Restrict decimal part to 2 digits
                                              form.setFieldValue(field.name, value, true);
                                            }}
                                            onKeyDown={(e) => {
                                              const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete", "."];
                                              const isCopyPaste = (e.ctrlKey || e.metaKey) && ["c", "v", "x", "a"].includes(e.key.toLowerCase());
                                              const isNumber = /^[0-9]$/.test(e.key);
                                              const isDot = e.key === ".";

                                              if (isCopyPaste) return;

                                              // Prevent multiple dots
                                              if (isDot && e.currentTarget.value.includes(".")) {
                                                e.preventDefault();
                                                return;
                                              }

                                              if (!isNumber && !isDot && !allowedKeys.includes(e.key)) {
                                                e.preventDefault();
                                              }
                                            }}
                                            onPaste={(e) => {
                                              e.preventDefault();
                                              const pastedData = e.clipboardData.getData('text');
                                              const cleanedData = pastedData.replace(/[^0-9.]/g, '');
                                              const parts = cleanedData.split('.');
                                              let result = parts[0].slice(0, 2);
                                              if (parts.length > 1) {
                                                result += '.' + parts[1].slice(0, 2);
                                              }
                                              form.setFieldValue(field.name, result, true);
                                            }}
                                            onBlur={() => {
                                              form.setFieldTouched(field.name, true, true);
                                            }}
                                            borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                          />
                                          {meta.touched && meta.error && (
                                            <Text color={colors.errorText} fontSize="sm" mt={1}>
                                              {meta.error}
                                            </Text>
                                          )}
                                        </>
                                      );
                                    }}
                                  </Field>
                                </Box>
                              </Flex>


                              <Flex gap={"20px"}>
                                <Box w={"50%"}>
                                  <FormLabel htmlFor="skills">
                                    {recruitConstant.skills}
                                    <span className="astrick">*</span>
                                  </FormLabel>
                                  <Field name="skills">
                                    {({ field, form, meta }) => {
                                      const value = Array.isArray(field.value) ? field.value : [];

                                      const baseOptions = requiredSkillsOptions.map(opt => ({
                                        label: opt.label,
                                        value: opt.value,
                                      }));

                                      const selectedOptions = value.map(v => ({
                                        label: v,
                                        value: v,
                                      }));
                                      const SKILL_REGEX = /^[a-zA-Z ]+$/;

                                      return (
                                        <>
                                          <CreatableSelect
                                            isMulti
                                            isDisabled={!permission?.update || isOverviewMode}
                                            value={selectedOptions}
                                            options={baseOptions}
                                            styles={{
                                              placeholder: (base) => ({
                                                ...base,
                                                fontSize: "14px",
                                                fontWeight: 400,
                                              }),
                                            }}
                                            placeholder="Select or type skills..."

                                            onInputChange={(input, { action }) => {
                                              if (action === "input-change" && SKILL_REGEX.test(input)) {
                                                return input;
                                              }
                                              return "";
                                            }}

                                            formatCreateLabel={(v) => `${v} (new)`}

                                            onCreateOption={(v) =>
                                              form.setFieldValue("skills", [...value, v.trim()])
                                            }

                                            onChange={(opts) =>
                                              form.setFieldValue("skills", opts.map(o => o.value))
                                            }
                                          />


                                          {meta.touched && meta.error && (
                                            <Text color={colors.errorText} fontSize="sm" mt={1}>
                                              {meta.error}
                                            </Text>
                                          )}
                                        </>
                                      );
                                    }}
                                  </Field>

                                </Box>
                                <Box w={"50%"}>
                                  <FormLabel htmlFor="noticePeriod">
                                    {recruitConstant.noticePeriod}
                                  </FormLabel>
                                  <Field name="noticePeriod">
                                    {({ field, meta }) => (
                                      <>
                                        <Select
                                          isDisabled={!permission?.update || isOverviewMode}
                                          {...field}
                                          defaultValue=""
                                          borderColor={
                                            meta.touched && meta.error
                                              ? colors.errorText
                                              : colors.borderColor
                                          }
                                        >
                                          <option selected hidden value="">
                                            {recruitConstant.noticePeriod}
                                          </option>
                                          {noticePeriodOptions.map((option, index) => (
                                            <option key={index} value={option?.value}>
                                              {option?.label}
                                            </option>
                                          ))}
                                        </Select>
                                        {meta.touched && meta.error && (
                                          <Text color={colors.errorText} fontSize="sm" mt={1}>
                                            {meta.error}
                                          </Text>
                                        )}
                                      </>
                                    )}
                                  </Field>
                                </Box>

                              </Flex>





                              <Flex gap={"20px"}>
                                <Box w={"50%"}>
                                  <FormLabel htmlFor="currentEmployer">
                                    {recruitConstant.currentEmployer}
                                    <span className="astrick">*</span>
                                  </FormLabel>
                                  <Field name="currentEmployer">
                                    {({ field, meta, form }) => {
                                      return (
                                        <>
                                          <Input
                                            isDisabled={!permission?.update || isOverviewMode}
                                            name={field.name}
                                            value={field.value || ''}
                                            placeholder={recruitConstant.enterCurrentEmployer}
                                            maxLength={100}
                                            onChange={(e) => {
                                              let value = e.target.value;
                                              if (value.startsWith(' ')) {
                                                value = value.trimStart();
                                              }
                                              value = value.replace(/[^a-zA-Z0-9\s]/g, ''); // Only letters, numbers, spaces
                                              value = value.replace(/\s{2,}/g, ' ');
                                              form.setFieldValue(field.name, value, true);
                                            }}
                                            onBlur={() => {
                                              const trimmedValue = (field.value || '').trim();
                                              form.setFieldValue(field.name, trimmedValue, true);
                                              form.setFieldTouched(field.name, true, true);
                                            }}
                                            borderColor={meta.touched && meta.error ? colors.errorText : colors.borderColor}
                                          />
                                          {meta.touched && meta.error && (
                                            <Text color={colors.errorText} fontSize="sm" mt={1}>
                                              {meta.error}
                                            </Text>
                                          )}
                                        </>
                                      );
                                    }}
                                  </Field>
                                </Box>

                                <Box w={"50%"}>
                                  <FormLabel htmlFor="currentJobTitle">
                                    {recruitConstant.jobtitle}
                                  </FormLabel>
                                  <Field name="currentJobTitle">
                                    {({ field, meta, form }) => {

                                      const currentValue = field.value; // can be normal or other-<custom>
                                      const customText = form.values.customJobTitle || "";

                                      // Show input if user selects "Other"
                                      const isOtherSelected = currentValue === "Other";

                                      // Always show "Other" in options
                                      const jobOptionsWithOther = [
                                        ...(jobTitleDropdownOptions || []).filter((opt) => opt.value !== "Other" && opt.value !== "others"),
                                        { label: "Other", value: "Other" },
                                      ];

                                      // Selected option: value must match option to highlight
                                      const selectedOption = currentValue?.startsWith("Other-")
                                        ? { label: `${currentValue.split("Other-")[1]}`, value: "Other" } // <- value = "Other"
                                        : jobOptionsWithOther.find((opt) => opt.value === currentValue) || null

                                      return (
                                        <>
                                          <>
                                            <ReactSelect
                                              isDisabled={!permission?.update || isOverviewMode}
                                              name={field.name}
                                              value={selectedOption}
                                              onBlur={() => form.setFieldTouched(field.name, true)}
                                              options={jobOptionsWithOther}
                                              className="basic-single-select reactSelect"
                                              classNamePrefix="select"
                                              onChange={(selectedOption) => {
                                                const selectedValue = selectedOption ? selectedOption.value : "";
                                                if (selectedValue === "Other") {
                                                  // Open text input with previous value if exists
                                                  const prevCustom = currentValue?.startsWith("Other-")
                                                    ? currentValue.split("Other-")[1]
                                                    : "";
                                                  form.setFieldValue("customJobTitle", prevCustom);
                                                  form.setFieldValue("currentJobTitle", "Other"); // keep dropdown selection as "Other"
                                                } else {
                                                  form.setFieldValue("currentJobTitle", selectedValue);
                                                  if (!selectedValue || originalCandidateData?.currentJobTitle?.startsWith('Other-')) {
                                                    form.setFieldValue("customJobTitle", "")
                                                  }
                                                }
                                              }}
                                              placeholder="Select Job Title"
                                              isClearable
                                              isSearchable
                                              styles={{
                                                control: (provided) => ({
                                                  ...provided,
                                                  borderColor:
                                                    meta.error ? colors.errorText : colors.borderColor,
                                                }),
                                              }}
                                            />

                                            {isOtherSelected && (
                                              <Box mt={2}>
                                                <Input
                                                  placeholder="Enter custom job title"
                                                  value={form.values.customJobTitle || ""}
                                                  autoFocus
                                                  onChange={(e) => {
                                                    let val = e.target.value
                                                    if (val.startsWith(" ")) return
                                                    form.setFieldValue("customJobTitle", val)
                                                  }}
                                                  onBlur={() => {
                                                    let customValue = form.values.customJobTitle
                                                      ?.trim()

                                                    if (customValue) {
                                                      form.setFieldValue("customJobTitle", customValue)
                                                      form.setFieldValue("currentJobTitle", `Other-${customValue}`)
                                                    } else {
                                                      if (originalCandidateData?.currentJobTitle.startsWith('Other-'))
                                                        form.setFieldValue("customJobTitle", "")
                                                      form.setFieldValue("currentJobTitle", "Other")
                                                    }
                                                  }}
                                                  onKeyDown={(e) => {
                                                    if (e.key === "Enter") {
                                                      e.preventDefault()
                                                      let customValue = form.values.customJobTitle
                                                        ?.trim()
                                                      if (customValue) {
                                                        form.setFieldValue("customJobTitle", customValue)
                                                        form.setFieldValue("currentJobTitle", `Other-${customValue}`)
                                                      }
                                                    }
                                                  }}
                                                />
                                              </Box>
                                            )}

                                            {meta.touched && (meta.error || (meta?.value === 'Other' && !form.values.customJobTitle)) && (
                                              <Text color={colors.errorText} fontSize="sm" mt={1}>
                                                {meta.error ?? ((meta?.value === 'Other' && !form.values.customJobTitle) ? 'Please enter a custom job title ' : '')}
                                              </Text>
                                            )}
                                          </>
                                        </>
                                      );
                                    }}
                                  </Field>
                                </Box>
                              </Flex>
                              <Flex gap={"20px"}>
                                <Box w={"50%"}>
                                  <FormLabel htmlFor="lastWorkingDate">
                                    {recruitConstant.lastWorkingDate}
                                  </FormLabel>
                                  <Field name="lastWorkingDate">
                                    {({ field, form, meta }) => {
                                      return (
                                        <>
                                          <CustomDatePicker
                                            isDisabled={!permission?.update || isOverviewMode}
                                            onBlur={() => form.setFieldTouched(field.name, true)}
                                            fullWidth={true}
                                            startDate={field.value}
                                            setStartDate={(date) => form.setFieldValue(field.name, date)}
                                          />
                                          {meta.touched && meta.error && (
                                            <Text color={colors.errorText} fontSize="sm" mt={1}>{meta.error}</Text>
                                          )}
                                        </>
                                      )
                                    }}
                                  </Field>
                                </Box>
                              </Flex>
                            </Box>

                            <Box className="createJobOpening-tabsPanelFooter">
                              <Button
                                className="theme-btn2 cancelBtn"
                                sx={{ textTransform: "capitalize" }}
                                variant="outline"
                                colorScheme={colors.error["100"]}
                                size="sm"
                                onClick={() => navigate("/recruitment/candidates")}
                              >
                                {recruitConstant.cancel}
                              </Button>

                              <Button
                                disabled={!tabStates[activeTabIndex]?.canProceed}
                                className="nextBtn"
                                variant="primary"
                                onClick={() =>
                                  handleNext(
                                    values,
                                    dirty,
                                    isValid,
                                    setErrors,
                                    setTouched
                                  )
                                }
                              >
                                {recruitConstant.next}
                              </Button>
                            </Box>
                          </TabPanel>
                        );
                      } else if (originalIndex === 1) {
                        // Attachments tab
                        return (
                          <TabPanel key={`tab-${originalIndex}`} className="createJobOpening-tabsPanel">
                            <Box className="createJobOpening-tabsPanelBody">
                              {/* Resume Upload */}
                              <Flex gap={"20px"}>
                                <Box w={"100%"}>
                                  <Field name="resume">
                                    {({ field, form, meta }) => {
                                      const hasPendingFile = pendingUploads.resume
                                      const hasValidationError = meta.touched && meta.error
                                      const hasExistingFile = id && jobData?.resume && !hasPendingFile && !hasValidationError
                                      const filename = hasExistingFile
                                        ? jobData?.resume?.split("/")?.pop()
                                        : hasPendingFile
                                          ? pendingUploads.resume.originalName
                                          : null

                                      return (
                                        <Flex align="center" gap={4}>
                                          <Box flex="1">
                                            <FileUpload
                                              isRequired
                                              isDisabled={!permission?.update || isOverviewMode}
                                              label={constant.resume}
                                              icon={AttachmentIcon}
                                              selectedFile={
                                                hasPendingFile
                                                  ? `Selected: ${hasPendingFile.originalName}`
                                                  : hasExistingFile
                                                    ? `Current: ${removeTimestamp(filename)}`
                                                    : null
                                              }
                                              title={constant.attachment}
                                              inputId="resume-upload"
                                              handleFileChange={(e) => {


                                                form.setFieldTouched("resume", true);
                                                handleFileSelection(
                                                  form.setFieldValue,
                                                  form.setFieldError,
                                                  "resume",
                                                  form.setFieldTouched
                                                )(e);
                                              }}
                                              errorText={
                                                meta.touched && showSizeError?.resume
                                                  ? recruitConstant.fileSizeExceed2MB
                                                  : meta.error
                                                    ? meta.error
                                                    : ""
                                              }
                                              type="file"
                                              borderColor={
                                                meta.touched && meta.error
                                                  ? colors.errorText
                                                  : colors.borderColor
                                              }
                                              accept={ACCEPTED_DOCUMENT_TYPES}
                                            />
                                          </Box>

                                          {(hasExistingFile || hasPendingFile) && (
                                            <Flex gap={2}>
                                              {hasExistingFile && (
                                                <Button
                                                  size="sm"
                                                  leftIcon={<DownloadIcon />}
                                                  onClick={() =>
                                                    handleDownloadAttachment(
                                                      jobData.resume,
                                                      filename
                                                    )
                                                  }
                                                  variant="outline"
                                                >
                                                  Download
                                                </Button>
                                              )}
                                              <IconButton
                                                isDisabled={!permission?.update || isOverviewMode}
                                                size="sm"
                                                icon={<CloseIcon />}
                                                onClick={() => handleRemoveFile(form.setFieldValue, "resume", form.setFieldError, form.setFieldTouched)}
                                                variant="outline"
                                                colorScheme="red"
                                                aria-label="Remove file"
                                                title="Remove file"
                                              />
                                            </Flex>
                                          )}
                                        </Flex>
                                      );
                                    }}
                                  </Field>
                                </Box>
                              </Flex>

                              {/* Cover Letter Upload */}
                              <Flex gap={"20px"}>
                                <Box w={"100%"}>
                                  <Field name="coverLetter">
                                    {({ field, form, meta }) => {
                                      const hasValidationError = meta.touched && meta.error
                                      const hasPendingFile = pendingUploads.coverLetter
                                      const hasExistingFile = id && jobData?.coverLetter && !hasPendingFile && !hasValidationError
                                      const filename = hasExistingFile
                                        ? jobData?.coverLetter?.split("/")?.pop()
                                        : hasPendingFile
                                          ? pendingUploads.coverLetter.originalName
                                          : null

                                      return (
                                        <Flex align="center" gap={4}>
                                          <Box flex="1">
                                            <FileUpload
                                              isDisabled={!permission?.update || isOverviewMode}
                                              label={constant.CoverLetter}
                                              icon={AttachmentIcon}
                                              selectedFile={
                                                hasPendingFile
                                                  ? `Selected: ${hasPendingFile.originalName}`
                                                  : hasExistingFile
                                                    ? `Current: ${removeTimestamp(filename)}`
                                                    : null
                                              }
                                              title={constant.attachment}
                                              inputId="cover-letter-upload"
                                              handleFileChange={handleFileSelection(
                                                form.setFieldValue,
                                                form.setFieldError,
                                                "coverLetter",
                                                form.setFieldTouched
                                              )}
                                              errorText={
                                                meta.touched && meta.error
                                                  ? meta.error
                                                  : showSizeError?.coverLetter
                                                    ? recruitConstant.fileSizeExceed2MB
                                                    : ""
                                              }
                                              type="file"
                                              borderColor={
                                                meta.touched && meta.error
                                                  ? colors.errorText
                                                  : showSizeError?.coverLetter
                                                    ? colors.errorText
                                                    : colors.borderColor

                                              }
                                              accept={ACCEPTED_DOCUMENT_TYPES}
                                            />
                                          </Box>

                                          {(hasExistingFile || hasPendingFile) && (
                                            <Flex gap={2}>
                                              {hasExistingFile && (
                                                <Button
                                                  size="sm"
                                                  leftIcon={<DownloadIcon />}
                                                  onClick={() =>
                                                    handleDownloadAttachment(
                                                      jobData.coverLetter,
                                                      filename
                                                    )
                                                  }
                                                  variant="outline"
                                                >
                                                  Download
                                                </Button>
                                              )}
                                              <IconButton
                                                isDisabled={!permission?.update || isOverviewMode}
                                                size="sm"
                                                icon={<CloseIcon />}
                                                onClick={() => handleRemoveFile(form.setFieldValue, "coverLetter", form.setFieldError, form.setFieldTouched)}
                                                variant="outline"
                                                colorScheme="red"
                                                aria-label="Remove file"
                                                title="Remove file"
                                              />
                                            </Flex>
                                          )}
                                        </Flex>
                                      );
                                    }}
                                  </Field>
                                </Box>
                              </Flex>
                            </Box>

                            <Box className="createJobOpening-tabsPanelFooter">
                              <Button onClick={handleBack} className="backBtn">
                                {constant.back}
                              </Button>
                              {!isOverviewMode && (
                                <Button
                                  disabled={
                                    addLoading ||
                                    editLoading ||
                                    (!id && !dirty) ||
                                    !isValid ||
                                    !permission?.update ||
                                    isAnyFileUploading
                                    || (activeTabIndex === 1 && (!pendingUploads.resume) && !isEditMode)
                                    || (isEditMode && !isDirty)
                                  }
                                  className="nextBtn"
                                  variant="primary"
                                  type="submit"
                                >
                                  {addLoading || editLoading || isAnyFileUploading ? (
                                    <Spinner size="sm" />
                                  ) : id ? (
                                    constant.update
                                  ) : (
                                    constant.save
                                  )}
                                </Button>
                              )}
                              {isOverviewMode && (
                                <Button
                                  onClick={() => navigate("/recruitment/candidates")}
                                  className="nextBtn"
                                  variant="primary"
                                  type="button"
                                >
                                  Return to Candidates
                                </Button>
                              )}
                            </Box>
                          </TabPanel>
                        );
                      } else if (originalIndex === 2) {
                        // Document Verification tab
                        return (
                          <TabPanel key={`tab-${originalIndex}`} className="createJobOpening-tabsPanel">
                            <Box className="createJobOpening-tabsPanelBody">
                              <DocumentVerificationTab
                                candidateId={id ? String(id) : undefined}
                                candidateName={jobData?.name}
                              />
                            </Box>
                          </TabPanel>
                        );
                      } else if (originalIndex === 3) {
                        // LOI tab
                        return (
                          <TabPanel key={`tab-${originalIndex}`} className="createJobOpening-tabsPanel">
                            <Box className="createJobOpening-tabsPanelBody">
                              <LOITab
                                candidateId={id ? String(id) : undefined}
                                candidateName={jobData?.name}
                                candidateEmail={jobData?.email}
                              />
                            </Box>
                          </TabPanel>
                        );
                      }
                      return null;
                    })}
                  </TabPanels>
                </Tabs>
              </Form>
            );
          }}
        </Formik >
      </Box >
    </>
  )
}

const CandidatesCreate = () => {
  const colors = globalStyles.colors;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [highestTabReached, setHighestTabReached] = useState(id ? 1 : 0);
  const { addLoading } = useSelector((state) => state.candidates);
  const { users } = useSelector((state) => state.users);
  const [editLoading, setEditLoading] = useState(false);
  const [jobData, setJobData] = useState(null);
  const [originalCandidateData, setOriginalCandidateData] = useState(null);
  const [showSizeError, setShowSizeError] = useState({
    resume: false,
    coverLetter: false,
  });
  const [permission] = HasAccess([accessModuleTitles.Candidates]);
  const [isOverviewMode, setIsOverviewMode] = useState(false)
  const location = useLocation();
  const { mode } = location.state || {};
  const [activeMainTab, setActiveMainTab] = useState(0);
  const [jobTitleDropdownOptions, setJobTitleDropdownOptions] = useState(jobTitleOptions);

  // Get current user role to filter tabs
  const getUserRole = useMemo(() => {
    try {
      const userData = localStorage.getItem('user');
      if (!userData) return null;
      const user = JSON.parse(userData);
      return user?.activeRoleId?.roleName || user?.role || null;
    } catch (error) {
      console.error('Error getting user role:', error);
      return null;
    }
  }, []);

  // Filter tabs - hide Document Verification and LOI for employees
  const visibleTabs = useMemo(() => {
    const userRole = getUserRole;
    if (userRole === 'employee') {
      // Hide Document Verification (index 2) and LOI (index 3) for employees
      return candidateTabs.filter((_, index) => index < 2);
    }
    if (userRole === 'reviewer') {
      // For reviewers, only show Document Verification tab (index 2)
      return candidateTabs.filter((_, index) => index === 2);
    }
    // For all other roles (recruiter, hiringManager, superAdmin, etc.), show all tabs
    return candidateTabs;
  }, [getUserRole]);

  const handleMainTabChange = (index) => {
    setActiveMainTab(index);
  };

  useEffect(() => {
    if (location.state?.activeMainTab !== undefined) {
      setActiveMainTab(location.state.activeMainTab);
    }
  }, [location.state]);

  const mergeJobTitleOptions = useCallback((dynamicTitles = []) => {
    const staticOptions = jobTitleOptions.filter((option) => option.value !== "Other" && option.value !== "others");
    const existingLabels = new Set(
      staticOptions.map((option) => String(option?.label || "").trim().toLowerCase())
    );

    const dynamicOptions = (dynamicTitles || [])
      .map((title) => String(title || "").trim())
      .filter(Boolean)
      .filter((title) => {
        const lower = title.toLowerCase();
        return lower !== "other" && !existingLabels.has(lower);
      })
      .map((title) => ({ value: title, label: title }));

    return [...staticOptions, ...dynamicOptions];
  }, []);

  const [pendingDeletions, setPendingDeletions] = useState({
    resume: null, // Will store { key, presignedUrl }
    coverLetter: null
  });
  const [removedFiles, setRemovedFiles] = useState({
    resume: false,
    coverLetter: false
  });
  // UPDATED: States for deferred upload
  const [pendingUploads, setPendingUploads] = useState({
    resume: null, // Will store { file, presignedUrl, filename }
    coverLetter: null
  })
  const [uploadingFiles, setUploadingFiles] = useState({
    resume: false,
    coverLetter: false
  })
  // const mode = sessionStorage.getItem("mode");
  useEffect(() => {
    const mode = sessionStorage.getItem("mode");
    if (mode === "overview") {
      setIsOverviewMode(true);
    } else {
      setIsOverviewMode(false);
    }
  }, []);
  const modeType = sessionStorage.getItem("mode");
  const isEditMode = useMemo(() => {
    return modeType === "edit"
  }, [])

  const s3HelperInstance = S3Helper.getInstance();
  // UPDATED: File change handler - only gets presigned URL, doesn't upload
  const handleFileSelection = (setFieldValue, setFieldError, fieldName, setFieldTouched) => async (e) => {
    const inputElement = e.target;

    const file = e.target.files[0]

    const clearInput = () => {
      if (inputElement) {
        inputElement.value = '';
      }
    }

    if (!file) {
      clearInput();
      return;
    }

    // Clear removal flag when new file is selected
    setRemovedFiles(prev => ({
      ...prev,
      [fieldName]: false
    }))
    setShowSizeError((prev) => ({
      ...prev,
      [fieldName]: false,
    }))
    // File size validation
    if (file.size > MAX_ATTACHMENT_FILE_SIZE) {
      console.error(`File size exceeds ${MAX_ATTACHMENT_FILE_SIZE_MB}MB`)
      setFieldError(fieldName, `File size exceeds ${MAX_ATTACHMENT_FILE_SIZE_MB}MB`)
      setFieldValue(fieldName, '')
      setShowSizeError((prev) => ({
        ...prev,
        [fieldName]: true,
      }))
      clearInput();
      setPendingUploads(prev => ({
        ...prev,
        [fieldName]: null
      }))
      return
    }

    // File validation
    const validation = validateS3File(file, {
      maxSizeInMB: MAX_ATTACHMENT_FILE_SIZE_MB,
      allowedExtensions: ['pdf', 'doc', 'docx', 'txt', 'png', 'jpg', 'jpeg']
    })

    if (!validation.valid) {
      setFieldError(fieldName, validation.error)
      setFieldValue(fieldName, '')
      clearInput();
      setPendingUploads(prev => ({
        ...prev,
        [fieldName]: null
      }))
      return
    }

    // If in edit mode and there's an existing file, prepare it for deletion
    if (isEditMode && id && jobData?.[fieldName]) {
      try {
        let user = null;
        const userStr = localStorage.getItem('user');
        if (userStr) {
          user = JSON.parse(userStr);
        }

        const existingFileKey = jobData[fieldName];
        const filename = existingFileKey.split('/').pop();
        const filePath = existingFileKey.replace(filename, '');

        const deleteData = [{
          fileName: filename,
          method: "DELETE",
          filePath: filePath,
          userId: user?._id || 'anonymous'
        }];

        // Get DELETE presigned URL
        const deletePresignedData = await s3HelperInstance.getPresignedUrl(
          filename,
          '',
          filePath,
          deleteData
        );

        // Store for execution on form submit
        setPendingDeletions(prev => ({
          ...prev,
          [fieldName]: {
            key: existingFileKey,
            presignedUrl: deletePresignedData[0].url,
            filename: filename
          }
        }));

      } catch (error) {
        console.error(`Failed to prepare DELETE for old ${fieldName}:`, error);
      }
    }
    try {
      const timestamp = Date.now();
      const extension = file.name.split('.').pop();
      const baseName = file.name.replace(/\.[^/.]+$/, '');
      const filename = `${timestamp}-${baseName}.${extension}`;

      const moduleName = 'candidates'
      const s3Path = generateS3Path(moduleName, id);
      let user = null;
      const userStr = localStorage.getItem('user');
      if (userStr) {
        user = JSON.parse(userStr);
      }
      const data = [
        {
          fileName: filename,
          method: "PUT",
          filePath: s3Path,
          userId: user?._id || 'anonymous'
        }
      ]

      const presignedData = await s3HelperInstance.getPresignedUrl(filename, file.type, s3Path, data);

      setPendingUploads(prev => ({
        ...prev,
        [fieldName]: {
          file: file,
          presignedUrl: presignedData[0].url,
          filename: filename,
          originalName: file.name,
          key: presignedData[0].key
        }
      }))

      setFieldValue(fieldName, filename)
      setShowSizeError((prev) => ({
        ...prev,
        [fieldName]: false,
      }))

      // Clear input to allow selecting the same file again
      clearInput();

    } catch (error) {
      console.error(`=== FILE PREPARATION ERROR: ${fieldName} ===`, error)
      setFieldError(fieldName, "Failed to prepare file. Please try again.")
      setFieldValue(fieldName, '')
      clearInput();
      setPendingUploads(prev => ({
        ...prev,
        [fieldName]: null
      }))
      toast.error(`Failed to prepare ${fileFieldMapping[fieldName]}`)
    }
  }

  const handleRemoveFile = async (setFieldValue, fieldName, setFieldError, setFieldTouched) => {
    // Clear any pending upload for this field
    const isExistingFile = isEditMode && id && jobData?.[fieldName];
    const isPendingFile = pendingUploads[fieldName];

    setPendingUploads(prev => ({
      ...prev,
      [fieldName]: null
    }));

    setFieldValue(fieldName, '');

    setRemovedFiles(prev => ({
      ...prev,
      [fieldName]: true
    }));

    // In edit mode, if there's an existing file, prepare DELETE presigned URL
    if (isExistingFile && !isPendingFile) {
      try {
        let user = null;
        const userStr = localStorage.getItem('user');
        if (userStr) {
          user = JSON.parse(userStr);
        }

        const existingFileKey = jobData[fieldName];
        const filename = existingFileKey.split('/').pop();
        const filePath = existingFileKey.replace(filename, '');

        const deleteData = [{
          fileName: filename,
          method: "DELETE",
          filePath: filePath,
          userId: user?._id || 'anonymous'
        }];

        // Get DELETE presigned URL
        const deletePresignedData = await s3HelperInstance.getPresignedUrl(
          filename,
          '',
          filePath,
          deleteData
        );

        // Store deletion info for later execution
        setPendingDeletions(prev => ({
          ...prev,
          [fieldName]: {
            key: existingFileKey,
            presignedUrl: deletePresignedData[0].url,
            filename: filename
          }
        }));

      } catch (error) {
        console.error(`Failed to prepare DELETE presigned URL for ${fieldName}:`, error);
        toast.error(`Failed to prepare file deletion for ${fieldName}`);
      }
    }

    // Update jobData to reflect removal
    if (id && jobData?.[fieldName]) {
      setJobData(prev => ({
        ...prev,
        [fieldName]: null
      }));
    }

    // Clear file input
    const inputElement = document.getElementById(`${fieldName}-upload`);
    if (inputElement) {
      inputElement.value = '';
    }

    // Handle resume required validation
    if (fieldName === 'resume') {
      setFieldValue(fieldName, '');
    }

    setTimeout(() => {
      if (fieldName === 'resume') {
        setFieldTouched(fieldName, true, false);
        const fieldDisplayName = fieldName === 'resume' ? 'Resume' : 'Cover Letter';
        setFieldError(fieldName, `${fieldDisplayName} is required`);
      }
    }, 0);
  };
  const executeAllPendingDeletions = async () => {
    const deletionPromises = [];

    Object.entries(pendingDeletions).forEach(([fieldName, deletionData]) => {
      if (deletionData) {
        const deletionPromise = async () => {
          try {

            // Execute DELETE using presigned URL
            await axios.delete(deletionData.presignedUrl);

            // toast.success(`${fieldName} removed successfully`);
          } catch (error) {
            console.error(`Failed to delete ${fieldName}:`, error);
            // Don't throw - log but continue with other operations
            console.warn(`Deletion failed for ${fieldName}, but continuing with update`);
          }
        };
        deletionPromises.push(deletionPromise());
      }
    });

    if (deletionPromises.length > 0) {
      await Promise.allSettled(deletionPromises); // Use allSettled to not fail entire operation
    }
  };

  const uploadAllPendingFiles = async () => {
    const uploadResults = {}
    const uploadPromises = []

    Object.entries(pendingUploads).forEach(([fieldName, uploadData]) => {
      if (uploadData) {
        const uploadPromise = async () => {
          try {
            setUploadingFiles(prev => ({ ...prev, [fieldName]: true }))

            const uploadResult = await s3HelperInstance.updatedUploadToS3(
              uploadData.file,
              uploadData.presignedUrl,
              (percent) => console.log(`Upload progress - ${fieldName}: ${percent}%`)
            )

            uploadResults[fieldName] = uploadResult.url
          } catch (error) {
            console.error(`Failed to upload ${fieldName}:`, error)
            throw new Error(`Failed to upload ${fieldName}: ${error.message}`)
          } finally {
            setUploadingFiles(prev => ({ ...prev, [fieldName]: false }))
          }
        }
        uploadPromises.push(uploadPromise())
      }
    })

    // Wait for all uploads to complete
    if (uploadPromises.length > 0) {
      await Promise.all(uploadPromises)
    }
    return uploadResults
  }

  // Download handler using pre-signed URLs
  const handleDownloadWithS3Helper = async (fileUrl, fileName) => {
    try {
      let user = null;
      const userStr = localStorage.getItem('user');
      if (userStr) {
        user = JSON.parse(userStr);
      }
      let downloadUrl = fileUrl;
      const data = [
        {
          fileName: fileName,
          method: "GET",
          filePath: fileUrl.replace(fileName, ''),
          userId: user?._id || 'anonymous'
        }
      ]

      if (!fileUrl.startsWith('http')) {
        const urlData = await s3HelperInstance.getDownloadUrl(data);

        downloadUrl = urlData.url;
      }

      const response = await axios.get(downloadUrl, {
        responseType: 'blob'
      });

      const blob = new Blob([response.data]);
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = removeTimestamp(fileName) || 'download';
      link.style.display = 'none';

      document.body.appendChild(link);
      link.click();

      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);

      toast.success('File downloaded successfully')
    } catch (error) {
      console.error('=== DOWNLOAD ERROR ===', error)
      toast.error('Failed to download file')
    }
  }
  const tabValidationSchemas = useMemo(
    () => ({
      0: Yup.object().shape({
        name: Yup.string()
          .required("Name is required")
          .test("no-blank", "Name cannot be empty or contain only spaces", (value) => value && value.trim().length > 0)
          .max(100, "Name cannot exceed 100 characters"),

        email: Yup.string()
          .required("Email is required")
          .test("no-blank", "Email cannot be empty", (value) => value && value.trim().length > 0)
          .test("valid-email", "Please enter a valid email (e.g., abc@xyz.com)", (value) => {
            if (!value) return true;

            // Check for invalid patterns
            if (value.includes('..')) return false;  // No consecutive dots
            if (value.includes('.@')) return false;  // No dot before @
            if (value.includes('@.')) return false;  // No dot after @

            // Must match valid email format
            const regex = /^[a-zA-Z0-9][a-zA-Z0-9._%+-]*@[a-zA-Z0-9][a-zA-Z0-9.-]*\.[a-zA-Z]{2,}$/;
            return regex.test(value);
          })
          .max(100, "Email cannot exceed 100 characters"),

        phone: Yup.string()
          .required("Phone number is required")
          .test("no-blank", "Phone number cannot be empty", (value) => value && value.trim().length > 0)
          .test("phone-format", "Please enter a valid Indian mobile number (exactly 10 digits starting with 6, 7, 8, or 9)", (value) => {
            if (!value || value.trim() === '') return true;
            const digitsOnly = value.replace(/\D/g, '');
            return digitsOnly.length === 10 && /^[6-9]/.test(digitsOnly);
          }),

        city: Yup.string()
          .test("no-blank", "City cannot be empty or contain only spaces", (value) => !value || (value && value.trim().length > 0))
          .matches(/^[a-zA-Z\s]*$/, "City can only contain letters and spaces")
          .max(50, "City cannot exceed 50 characters"),

        state: Yup.string(),

        currentCTC: Yup.string()
          .test("no-blank", "Current CTC cannot be empty", (value) => !value || (value && value.trim().length > 0))
          .matches(/^\d{1,2}(\.\d{0,2})?$/, {
            message: "Current CTC must be in LPA with max 2 digits before decimal",
            excludeEmptyString: true,
          }),

        expectedCTC: Yup.string()
          .test("no-blank", "Expected CTC cannot be empty", (value) => !value || (value && value.trim().length > 0))
          .matches(/^\d{1,2}(\.\d{0,2})?$/, {
            message: "Expected CTC must be in LPA with max 2 digits before decimal",
            excludeEmptyString: true,
          }),

        experienceRange: Yup.string().required("Experience range is required"),

        highestQualification: Yup.string().required("Qualification is required"),

        currentJobTitle: Yup.string().test(
          "custom-job-title",
          "Please enter a custom job title",
          (value, context) => value !== "Other" || !!context.parent.customJobTitle?.trim()
        ),

        currentEmployer: Yup.string()
          .required("Current employer is required")
          .test("no-blank", "Current employer cannot be empty or contain only spaces", (value) => value && value.trim().length > 0)
          .matches(/^[a-zA-Z0-9\s]+$/, "Current employer can only contain letters, numbers and spaces")
          .max(100, "Current employer cannot exceed 100 characters"),

        skills: Yup.array()
          .of(Yup.string().required())
          .min(1, "At least one skill is required")
          .required("Skills are required"),

        status: Yup.string().required("Status is required"),

        noticePeriod: Yup.string(),

        lastWorkingDate: Yup.date()
          .nullable()
          .transform((value, originalValue) => (originalValue === "" ? null : value)),

        source: Yup.string().required("Source is required"),

        owner: Yup.string().required("Owner is required"),
      }),
      1: Yup.object().shape({
        resume: Yup.string().required("Resume is required"),
        coverLetter: Yup.string().nullable(),
      }),
    }),
    []
  );

  const isTabValid = useCallback(
    (values, tabIndex) => {
      try {
        // For tab 0 (Candidate Details), use schema validation
        if (tabIndex === 0) {
          tabValidationSchemas[0].validateSync(values, {
            abortEarly: false,
          });
          return true;
        }

        // For tab 1 (attachments), use custom validation logic
        if (tabIndex === 1) {
          // Check resume
          const hasResumeFile = pendingUploads.resume ||
            (id && jobData?.resume && !removedFiles.resume);

          return hasResumeFile;
        }

        // For other tabs (2, 3), no validation needed
        return true;
      } catch (error) {
        return false;
      }
    },
    [tabValidationSchemas, pendingUploads, id, jobData, removedFiles]
  );

  const getTabStates = useCallback(
    (values, dirty, isValid, currentTabIndex) => {
      const tabStates = {};
      const totalTabs = candidateTabs.length; // 4 tabs

      // Find the first invalid tab among visited tabs (only check tabs 0 and 1 which have validation)
      let firstInvalidTab = null;
      for (let i = 0; i <= Math.min(highestTabReached, 1); i++) {
        if (!isTabValid(values, i)) {
          firstInvalidTab = i;
          break;
        }
      }

      // Process all tabs (0-3)
      for (let i = 0; i < totalTabs; i++) {
        const tabValid = isTabValid(values, i);

        if (i < currentTabIndex) {
          // Previous tabs - always accessible and check if valid
          tabStates[i] = { isAccessible: true, isValid: tabValid };
        } else if (i === currentTabIndex) {
          // Current tab - always accessible
          tabStates[i] = {
            isAccessible: true,
            isValid: tabValid,
            canProceed: tabValid,
          };
        } else if (firstInvalidTab !== null && i > firstInvalidTab && i <= 1) {
          // Tabs after first invalid tab (only for tabs 0-1) - not accessible
          tabStates[i] = { isAccessible: false, isValid: false, canProceed: false };
        } else if (i <= 1 && i <= highestTabReached) {
          // Previously visited tabs (0-1) that are ahead
          tabStates[i] = { isAccessible: true, isValid: tabValid, canProceed: false };
        } else if (i <= 1 && i === currentTabIndex + 1) {
          // Next tab (0-1) - accessible if current tab is valid
          const currentTabValid = isTabValid(values, currentTabIndex);
          tabStates[i] = { isAccessible: currentTabValid, isValid: false, canProceed: false };
        } else if (i > 1) {
          // Tabs 2 and 3 (Document Verification, LOI) - always accessible if no invalid tabs before them
          if (firstInvalidTab === null || currentTabIndex >= 1) {
            tabStates[i] = { isAccessible: true, isValid: true, canProceed: true };
          } else {
            tabStates[i] = { isAccessible: false, isValid: false, canProceed: false };
          }
        } else {
          // Future tabs not yet reached
          tabStates[i] = { isAccessible: false, isValid: false, canProceed: false };
        }
      }
      return tabStates;
    },
    [isTabValid, highestTabReached]
  );
  const handleTabChange = useCallback(
    (index, values, dirty, isValid) => {
      if (index < activeTabIndex) {
        setActiveTabIndex(index);
        return;
      }

      if (index === activeTabIndex) {
        return;
      }

      const tabStates = getTabStates(values, dirty, isValid, activeTabIndex);

      if (tabStates[index]?.isAccessible) {
        setActiveTabIndex(index);
      } else {
        toast.error("Please complete the current step before proceeding");
      }
    },
    [activeTabIndex, getTabStates]
  );


  const handleNext = useCallback(
    (values, dirty, isValid, setErrors, setTouched) => {
      if (activeTabIndex < 1) {
        const currentTabValid = isTabValid(values, activeTabIndex);

        if (currentTabValid) {
          const newTabIndex = activeTabIndex + 1;
          setActiveTabIndex(newTabIndex);
          if (newTabIndex > highestTabReached) {
            setHighestTabReached(newTabIndex);
          }
        } else {
          try {
            tabValidationSchemas[activeTabIndex].validateSync(values, {
              abortEarly: false,
            });
          } catch (error) {
            const errors = {};
            const touchedFields = {};

            console.group(`❌ Validation failed for Tab ${activeTabIndex}`);
            if (error.inner && error.inner.length > 0) {
              error.inner.forEach((err, i) => {
                errors[err.path] = err.message;
                touchedFields[err.path] = true;
                console.error(`${i + 1}. Field: "${err.path}" — ${err.message}`);
              });
            } else {
              // Fallback for unexpected error shapes
              console.error("Validation error:", error);
            }
            console.groupEnd();

            // Optional: pretty summary table
            console.table(errors);

            setErrors(errors);
            setTouched(touchedFields);

            //  Toast only shows when there are actual validation issues
            toast.error("Please fill all required fields before proceeding");
          }
        }
      }
    },
    [activeTabIndex, isTabValid, tabValidationSchemas, highestTabReached]
  );

  const handleBack = useCallback(() => {
    if (activeTabIndex > 0) {
      setActiveTabIndex(activeTabIndex - 1);
    }
  }, [activeTabIndex]);

  // KEEP ALL EXISTING useEffects
  useEffect(() => {
    dispatch(getDepartments());
    dispatch(fetchUserData());
  }, [dispatch]);

  useEffect(() => {
    const fetchJobTitles = async () => {
      try {
        const response = await getApi('api/recruitment/candidates/job-titles');
        const dynamicTitles = response?.data?.data || [];
        setJobTitleDropdownOptions(mergeJobTitleOptions(dynamicTitles));
      } catch (error) {
        console.error('Failed to fetch candidate job titles:', error);
        setJobTitleDropdownOptions(mergeJobTitleOptions([]));
      }
    };

    fetchJobTitles();
  }, [mergeJobTitleOptions]);

  useEffect(() => {
    if (id) {
      const fetchTaskData = async () => {
        try {
          const result = await getApi(API_PATHS.CANDIDATE_LIST, id);

          // Customizing "Other-" fields for dropdowns
          let customiseResult = {
            ...(result?.data?.candidate?.currentJobTitle?.startsWith("Other-")
              ? {
                customJobTitle: result?.data?.candidate?.currentJobTitle.replace(
                  "Other-",
                  ""
                ),
              }
              : {}),

            ...(result?.data?.candidate?.highestQualification?.startsWith(
              "Other-"
            )
              ? {
                customHighestQualification:
                  result?.data?.candidate?.highestQualification.replace(
                    "Other-",
                    ""
                  ),
              }
              : {}),

            ...(result?.data?.candidate?.source?.startsWith("Other-")
              ? {
                customSource: result?.data?.candidate?.source.replace(
                  "Other-",
                  ""
                ),
              }
              : {}),

            //NEW: Handle custom skill (Other-skill)
            ...(Array.isArray(result?.data?.candidate?.skills)
              ? {
                customSkill: result?.data?.candidate?.skills.find((s) =>
                  s.startsWith("Other-")
                )
                  ? result?.data?.candidate?.skills
                    .find((s) => s.startsWith("Other-"))
                    .replace("Other-", "")
                  : "",
              }
              : {}),
          };

          // all customized values with candidate data
          const updatedRes = {
            ...result?.data?.candidate,
            owner: result?.data?.candidate?.owner?._id,
            ...customiseResult,
            currentCTC:
              result?.data?.candidate?.currentCTC ||
              result?.data?.candidate?.ctc ||
              "",
            expectedCTC:
              result?.data?.candidate?.expectedCTC ||
              result?.data?.candidate?.ectc ||
              "",
          };

          // Set state for form prefill
          setJobData(updatedRes);
          setOriginalCandidateData(updatedRes);
        } catch (e) {
          toast.error(constant.somethingWrong);
        }
      };

      fetchTaskData();
    }
  }, [id]);

  const EditData = async (values) => {
    try {
      setEditLoading(true);

      const result = await dispatch(
        updateCandidate({
          id,
          values,
          resetForm: null,
          navigate,
        })
      );
    } catch (e) {
      toast.error(constant.somethingWrong);
    } finally {
      setEditLoading(false);
    }
  };

  const handleDownloadAttachment = async (attachmentUrl, filename) => {
    try {

      await handleDownloadWithS3Helper(attachmentUrl, filename);
    } catch (error) {
      console.error("Download attachment error:", error);
      try {
        await dispatch(downloadAttachment({ attachmentUrl, filename }));
      } catch (fallbackError) {
        console.error("Fallback download also failed:", fallbackError);
      }
    }
  };

  const handleFormSubmit = async (values, { resetForm, isValid, errors, setErrors, setTouched }) => {
    try {
      // Validate files before proceeding
      const hasResumeFile = pendingUploads.resume || (id && jobData?.resume && !pendingDeletions.resume);

      if (!hasResumeFile) {
        setErrors(prev => ({ ...prev, resume: 'Resume is required' }));
        setTouched(prev => ({ ...prev, resume: true }));
        toast.error('Resume is required');
        return;
      }

      // In edit mode, execute pending deletions FIRST
      if (isEditMode && id) {
        await executeAllPendingDeletions();
      }
      // Handle "Other" custom skill before API call
      if (values.skills.includes("Other") && values.customSkill) {
        values.skills = values.skills
          .filter((skill) => skill !== "Other")
          .concat(`Other-${values.customSkill.trim()}`);
      }

      // Then upload all new/pending files
      const uploadedUrls = await uploadAllPendingFiles();


      const processedValues = { ...values };

      // Use uploaded URLs for new files
      Object.entries(uploadedUrls).forEach(([fieldName, url]) => {

        processedValues[fieldName] = extractS3KeyFlexible(url);
      });

      // For fields with pending deletions but no new upload, set to null
      Object.entries(pendingDeletions).forEach(([fieldName, deletionData]) => {
        if (deletionData && !uploadedUrls[fieldName]) {
          processedValues[fieldName] = null;
        }
      });

      // Apply capitalization to the name field before submission
      const cleanedValues = {
        ...processedValues,
        name: capitalizeWords(processedValues.name),
      };

      const attachmentFields = ["resume", "coverLetter"];
      const attachmentValues = {};

      attachmentFields.forEach((field) => {
        attachmentValues[field] = cleanedValues[field];
      });

      const generalCleanedValues = cleanFormDataCandidate(cleanedValues);

      if (id && values.currentJobTitle === "") {
        generalCleanedValues.currentJobTitle = "";
        generalCleanedValues.customJobTitle = "";
      }

      attachmentFields.forEach((field) => {
        generalCleanedValues[field] = attachmentValues[field];
      });

      if (id) {
        await EditData(generalCleanedValues);
      } else {
        await dispatch(
          addCandidate({
            values: generalCleanedValues,
            resetForm,
            navigate,
          })
        );
      }

      // Clear all pending operations after successful submission
      setPendingUploads({ resume: null, coverLetter: null });
      setPendingDeletions({ resume: null, coverLetter: null });

    } catch (error) {
      console.error("Form submission error:", error);
      toast.error("Failed to save candidate");
    }
  };

  // Check if any files are currently uploading
  const isAnyFileUploading = uploadingFiles.resume



  return (
    <>
      <div >
        <ActionNavbar isCreatePage={true} />
        <Stack>
          {
            id ?
              <>
                <Tabs index={activeMainTab} onChange={handleMainTabChange}>
                  <TabList className="noRadiusTabs">
                    <Tab>
                      Overview
                    </Tab>
                    <Tab>
                      Additional Info
                    </Tab>
                  </TabList>

                  <TabPanels mt={2}>
                    <TabPanel>
                      <OverviewPanel
                        navigate={navigate}
                        isOverviewMode={isOverviewMode}
                        id={id}
                        jobData={jobData}
                        handleFormSubmit={handleFormSubmit}
                        handleFileSelection={handleFileSelection}
                        handleRemoveFile={handleRemoveFile}
                        handleDownloadAttachment={handleDownloadAttachment}
                        pendingUploads={pendingUploads}
                        users={users}
                        permission={permission}
                        colors={colors}
                        activeTabIndex={activeTabIndex}
                        getTabStates={getTabStates}
                        handleTabChange={handleTabChange}
                        handleNext={handleNext}
                        handleBack={handleBack}
                        addLoading={addLoading}
                        editLoading={editLoading}
                        isAnyFileUploading={isAnyFileUploading}
                        isEditMode={isEditMode}
                        originalCandidateData={originalCandidateData}
                        showSizeError={showSizeError}
                        visibleTabs={visibleTabs}
                        getUserRole={getUserRole}
                        jobTitleDropdownOptions={jobTitleDropdownOptions}
                      />
                    </TabPanel>

                    <TabPanel display={'flex'} flexDirection={'column'} gap={6}>
                      <Box className="createJobOpening-breadCrumb">
                        <ArrowBackIcon onClick={() => navigate(-1)} fontSize="20px" cursor={"pointer"} />
                        <Text className="createJobOpening-pageTitle">
                          {/* {isOverviewMode ? "Overview" : id ? constant.editJobOpening : constant.createJobOpening} */}
                          {constant.additionalInfo}
                        </Text>
                      </Box>
                      <Box>
                        <Box width={'100%'} padding={4} borderBottom={"1px"} borderColor={'#e9ebec'} borderTopRadius={"xl"} backgroundColor={'white'}>
                          <Text fontWeight={700} fontSize={16} >Interview</Text>
                        </Box>
                        <Interview
                          customApiEndpoint={id ? `api/recruitment/candidates/${id}/interviews` : undefined}
                        />
                      </Box>

                      <Box>
                        <Box width={'100%'} padding={4} borderBottom={"1px"} borderColor={'#e9ebec'} borderTopRadius={"xl"} backgroundColor={'white'}>
                          <Text fontWeight={700} fontSize={16} >Application</Text>
                        </Box>
                        <Application
                          customApiEndpoint={id ? `api/recruitment/candidates/${id}/applications` : undefined}
                        />
                      </Box>

                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </>
              :
              <>
                <OverviewPanel
                  navigate={navigate}
                  isOverviewMode={isOverviewMode}
                  id={id}
                  jobData={jobData}
                  handleFormSubmit={handleFormSubmit}
                  handleFileSelection={handleFileSelection}
                  handleRemoveFile={handleRemoveFile}
                  handleDownloadAttachment={handleDownloadAttachment}
                  pendingUploads={pendingUploads}
                  users={users}
                  permission={permission}
                  colors={colors}
                  activeTabIndex={activeTabIndex}
                  getTabStates={getTabStates}
                  handleTabChange={handleTabChange}
                  handleNext={handleNext}
                  handleBack={handleBack}
                  addLoading={addLoading}
                  editLoading={editLoading}
                  isAnyFileUploading={isAnyFileUploading}
                  isEditMode={isEditMode}
                  originalCandidateData={originalCandidateData}
                  showSizeError={showSizeError}
                  visibleTabs={visibleTabs}
                  getUserRole={getUserRole}
                  jobTitleDropdownOptions={jobTitleDropdownOptions}
                />
              </>
          }
        </Stack>
      </div>
    </>
  );
};

export default CandidatesCreate;
